import {materialConnection} from "#material/nodes/base/connection/shorthand"
import {Value} from "#material/nodes/input/value/value"
import type {OutputMaterialConnection} from "#material/sockets/definition"

export const value = (value: number): OutputMaterialConnection<"float"> => {
    return materialConnection(new Value({parameters: {inputs: {}, settings: {value}}}), "value")
}
